import type { InfiniteData, QueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import type { DictationFeedbackRating } from '../../contracts';

import { DICTATION_LOGS_INFINITE_KEY } from '../../contracts';
import type { DictationsResponse } from '../api/logs';

/** Updates one saved rating across every loaded logs/search/date cache variant. */
export const setDictationFeedbackRatingInLogsCache = (
  queryClient: QueryClient,
  dictationId: string,
  rating: DictationFeedbackRating
): void => {
  queryClient.setQueriesData<InfiniteData<DictationsResponse>>(
    { queryKey: [DICTATION_LOGS_INFINITE_KEY] },
    (data) => {
      if (!data) return data;

      return produce(data, (draft) => {
        draft.pages.forEach((page) => {
          page.dictations.forEach((dictation) => {
            if (dictation.dictation_id === dictationId) {
              dictation.feedback_rating = rating;
            }
          });
        });
      });
    }
  );
};
